// Auth
const LOGIN_URL = "/auth/login";
const FORGOT_PASSWORD_URL = "/auth/reset-password-otp";
const RESEND_OTP_URL = "/auth/reset-password-otp";
const OTP_VERIFICATION_URL = "/auth/verify-otp";
const SET_NEW_PASSWORD_URL = "/auth/change-password";
const REGISTER_URL = "/auth/register";
const LOGOUT_URL = "/auth/logout";
const REFRESH_TOKEN_URL = "/auth/refresh";
const AUTH_SESSIONS_URL = "/auth/sessions";
const AUTH_SESSION_REVOKE_URL = "/auth/sessions";
const AUTH_SESSION_REVOKE_OTHERS_URL = "/auth/sessions/revoke-others";

//Zones
const ZONE_ADD_URL = "/zone/zone-create";
const ZONE_LIST_URL = "/zone/zone-list";
const ZONE_DETAILS_URL = "/zone";
const ZONE_UPDATE_URL = "/zone/zone-update";
const ZONE_DELETE_URL = "/zone";
const ZONE_EXPORT_URL = "/zone/zone-export";
const ZONE_IMPORT_URL = "/zone/zone-import";
const ZONE_SAMPLE_URL = "/zone/zone-sample";

// Wards
const WARDS_ADD_URL = "/ward/ward-create";
const WARDS_LIST_URL = "/ward/ward-list";
const WARDS_DETAILS_URL = "/ward/find-one";
const WARDS_UPDATE_URL = "/ward";
const WARDS_DELETE_URL = "/ward";
const WARD_EXPORT_URL = "/ward/ward-export";
const WARD_IMPORT_URL = "/ward/ward-import";
const WARD_SAMPLE_URL = "/ward/ward-sample";

const NOTIFICATION_GET_URL = "/notification/list";
const NOTIFICATION_PUT_URL = "/notification/update";

// User
const USER_ADD_URL = "/user/user-create";
const USER_LIST_URL = "/user/user-list";
const USER_EXPORT_URL = "/user/user-export";
const USER_HIERARCHY_TREE_URL = "/user/hierarchy-tree";
const USER_DETAILS_URL = "/user";
const USER_UPDATE_URL = "/user";
// const USER_UPDATE_URL = "/user/update";
const UPDATE_USER_PASSWORD = "/user/update/password";
const USER_DELETE_URL = "/user";

// user payment
const USER_PAYMENT_DETAILS_URL = "/user-payment/find-one";
const USER_PAYMENT_ADD_URL = "/user-payment/create";
const USER_PAYMENT_UPDATE_URL = "/user-payment/update";

// Roles
const ROLE_ADD_URL = "/role";
const ROLE_LIST_URL = "/role";
const ROLE_DETAILS_URL = "/role";
const ROLE_UPDATE_URL = "/role";
const ROLE_DELETE_URL = "/role";

// Permission
const PERMISSION_ADD_URL = "/permission";
const PERMISSION_LIST_URL = "/permission";
const PERMISSION_DETAILS_URL = "/permission/find-one";
const PERMISSION_UPDATE_URL = "/permission";
const PERMISSION_DELETE_URL = "/permission";
const PERMISSION_AND_ROLE_LIST_URL = "/permission/all";

// Settings
const SETTING_ADD_URL = "/setting/create";
const SETTING_LIST_URL = "/setting/find-one";

// Config
const CONFIG_CREATE_URL = "/config/config-create";
const CONFIG_LIST_URL = "/config/config-list";
const CONFIG_UPDATE_URL = "/config/config-update";
const CONFIG_DELETE_URL = "/config/";
const CONFIG_SECTION_URL = "/config/config-section";

// state
const CREATE_STATE_URL = "/state/state-create";
const STATE_LIST_URL = "/state/state-list";
const GET_STATE_URL = "/state/";
const UPDATE_STATE_URL = "/state/state-update";
const DELETE_STATE_URL = "/state/";
const STATE_EXPORT_URL = "/state/state-export";
const STATE_IMPORT_URL = "/state/state-import";
const STATE_SAMPLE_URL = "/state/state-sample";

// city
const CREATE_CITY_URL = "/city/city-create";
const GET_CITIES_URL = "/city/city-list";
const GET_CITY_URL = "/city/";
const DELETE_CITY_URL = "/city";
const UPDATE_CITY_URL = "/city/city-update";
const CITY_EXPORT_URL = "/city/city-export";
const CITY_IMPORT_URL = "/city/city-import";
const CITY_SAMPLE_URL = "/city/city-sample";

// Location
const CREATE_LOCATION_URL = "/location/location-create";
const LOCATION_LIST_URL = "/location/location-list";
const LOCATION_EXPORT_URL = "/location/location-export";
const LOCATION_IMPORT_URL = "/location/location-import";
const LOCATION_SAMPLE_URL = "/location/location-sample";
const LOCATION_DETAILS_URL = "/location";
const LOCATION_UPDATE_URL = "/location";
const LOCATION_DELETE_URL = "/location";
const locationHistoryUrl = (id) => `/location/${id}/history`;
const locationDevicesUrl = (id) => `/location/${id}/devices`;
const locationAssignDeviceUrl = (id) => `/location/${id}/assign-device`;
const locationUnassignDeviceUrl = (id) => `/location/${id}/unassign-device`;
const locationLidarTelemetryUrl = (id) => `/location/${id}/lidar-telemetry`;
const locationLidarTelemetryChartUrl = (id) =>
  `/location/${id}/lidar-telemetry/chart`;
const locationSensorTelemetryUrl = (id) => `/location/${id}/sensor-telemetry`;
const locationSensorTelemetryChartUrl = (id) =>
  `/location/${id}/sensor-telemetry/chart`;

// FILE
const FILE_UPLOAD_URL = "/file-upload";

// Device
const DEVICE_CREATE_URL = "/device/device-create";
const DEVICE_LIST_URL = "/device/device-list";
const DEVICE_EXPORT_URL = "/device/device-export";
const DEVICE_IMPORT_URL = "/device/device-import";
const DEVICE_SAMPLE_URL = "/device/device-sample";
const DEVICE_RAILWAY_IMPORT_URL = "/device/device-railway-import";
const DEVICE_RAILWAY_SAMPLE_URL = "/device/device-railway-sample";
const DEVICE_ALERT_CONTACTS_LIST_URL = "/device/alert-contacts";
const DEVICE_ALERT_CONTACTS_IMPORT_URL = "/device/alert-contacts-import";
const DEVICE_ALERT_CONTACTS_SAMPLE_URL = "/device/alert-contacts-sample";
const deviceAlertContactsUrl = (id) => `/device/${id}/alert-contacts`;
const DEVICE_DETAILS_URL = "/device";
const DEVICE_UPDATE_URL = "/device";
const DEVICE_DELETE_URL = "/device";
const deviceHistoryUrl = (id) => `/device/${id}/history`;
const deviceActivityUrl = (id) => `/device/${id}/activity`;
const deviceLidarTelemetryUrl = (id) => `/device/${id}/lidar-telemetry`;
const deviceLidarTelemetryChartUrl = (id) => `/device/${id}/lidar-telemetry/chart`;
const deviceSensorTelemetryUrl = (id) => `/device/${id}/sensor-telemetry`;
const deviceSensorTelemetryChartUrl = (id) => `/device/${id}/sensor-telemetry/chart`;
const deviceUnassignLocationUrl = (id) => `/device/${id}/unassign-location`;
const deviceLidarCalUrl = (id) => `/device/${id}/lidar-cal`;

// Dashboard analytics
const DASHBOARD_STATS_URL = "/sensor-data/dashboard-stats";
const DASHBOARD_LIVE_URL = "/sensor-data/dashboard-live";
const DASHBOARD_HISTOGRAMS_URL = "/sensor-data/dashboard-histograms";
const DASHBOARD_HISTOGRAMS_EXPORT_URL =
  "/sensor-data/dashboard-histograms/export";
const DASHBOARD_HISTOGRAMS_EXPORT_DATA_URL =
  "/sensor-data/dashboard-histograms/export-data";
const PREDICTION_URL = "/sensor-data/device";

// OTA
const OTA_FIRMWARE_UPLOAD_URL = "/ota/firmware-upload";
const OTA_FIRMWARE_LIST_URL = "/ota/firmware-list";
const OTA_SESSION_LIST_URL = "/ota/session-list";
const OTA_CAMPAIGN_LIST_URL = "/ota/campaign-list";
const OTA_CAMPAIGN_ACTIVE_URL = "/ota/campaign-active";
const OTA_DEPLOY_URL = "/ota/deploy";
const otaCampaignRetryUrl = (sessionId) =>
  `/ota/campaign/${sessionId}/retry-failed`;
const otaCampaignLogUrl = (sessionId) =>
  `/ota/campaign/${sessionId}/log`;
const OTA_EQUIPMENT_TARGETS_URL = "/ota/equipment-targets";
const OTA_TRIGGER_URL = "/ota/trigger";
const OTA_SUBMIT_URL = "/ota/submit";
const otaClearRetainedUrl = (mqttDeviceId) =>
  `/ota/clear-retained/${encodeURIComponent(mqttDeviceId)}`;
const otaResetRetryUrl = (mqttDeviceId) =>
  `/ota/reset-retry/${encodeURIComponent(mqttDeviceId)}`;

export {
  // notification
  NOTIFICATION_GET_URL,
  NOTIFICATION_PUT_URL,

  //Auth
  LOGIN_URL,
  FORGOT_PASSWORD_URL,
  OTP_VERIFICATION_URL,
  SET_NEW_PASSWORD_URL,
  RESEND_OTP_URL,
  REGISTER_URL,
  LOGOUT_URL,
  REFRESH_TOKEN_URL,
  AUTH_SESSIONS_URL,
  AUTH_SESSION_REVOKE_URL,
  AUTH_SESSION_REVOKE_OTHERS_URL,

  //Zones
  ZONE_ADD_URL,
  ZONE_LIST_URL,
  ZONE_DETAILS_URL,
  ZONE_UPDATE_URL,
  ZONE_DELETE_URL,
  ZONE_EXPORT_URL,
  ZONE_IMPORT_URL,
  ZONE_SAMPLE_URL,

  //Wards
  WARDS_ADD_URL,
  WARDS_LIST_URL,
  WARDS_DETAILS_URL,
  WARDS_UPDATE_URL,
  WARDS_DELETE_URL,
  WARD_EXPORT_URL,
  WARD_IMPORT_URL,
  WARD_SAMPLE_URL,

  // User
  USER_ADD_URL,
  USER_LIST_URL,
  USER_EXPORT_URL,
  USER_HIERARCHY_TREE_URL,
  USER_DETAILS_URL,
  USER_UPDATE_URL,
  USER_DELETE_URL,
  UPDATE_USER_PASSWORD,

  // user payment
  USER_PAYMENT_DETAILS_URL,
  USER_PAYMENT_ADD_URL,
  USER_PAYMENT_UPDATE_URL,

  // Roles
  ROLE_ADD_URL,
  ROLE_LIST_URL,
  ROLE_DETAILS_URL,
  ROLE_UPDATE_URL,
  ROLE_DELETE_URL,

  // Permission
  PERMISSION_ADD_URL,
  PERMISSION_LIST_URL,
  PERMISSION_DETAILS_URL,
  PERMISSION_UPDATE_URL,
  PERMISSION_DELETE_URL,
  PERMISSION_AND_ROLE_LIST_URL,

  // settings
  SETTING_ADD_URL,
  SETTING_LIST_URL,

  // config
  CONFIG_CREATE_URL,
  CONFIG_LIST_URL,
  CONFIG_UPDATE_URL,
  CONFIG_DELETE_URL,
  CONFIG_SECTION_URL,

  // state
  CREATE_STATE_URL,
  STATE_LIST_URL,
  GET_STATE_URL,
  UPDATE_STATE_URL,
  DELETE_STATE_URL,
  STATE_EXPORT_URL,
  STATE_IMPORT_URL,
  STATE_SAMPLE_URL,

  // city
  CREATE_CITY_URL,
  GET_CITIES_URL,
  GET_CITY_URL,
  UPDATE_CITY_URL,
  DELETE_CITY_URL,
  CITY_EXPORT_URL,
  CITY_IMPORT_URL,
  CITY_SAMPLE_URL,

  // location
  CREATE_LOCATION_URL,
  LOCATION_LIST_URL,
  LOCATION_EXPORT_URL,
  LOCATION_IMPORT_URL,
  LOCATION_SAMPLE_URL,
  LOCATION_DETAILS_URL,
  LOCATION_UPDATE_URL,
  LOCATION_DELETE_URL,
  locationHistoryUrl,
  locationDevicesUrl,
  locationAssignDeviceUrl,
  locationUnassignDeviceUrl,
  locationLidarTelemetryUrl,
  locationLidarTelemetryChartUrl,
  locationSensorTelemetryUrl,
  locationSensorTelemetryChartUrl,

  // device
  DEVICE_CREATE_URL,
  DEVICE_LIST_URL,
  DEVICE_EXPORT_URL,
  DEVICE_IMPORT_URL,
  DEVICE_SAMPLE_URL,
  DEVICE_RAILWAY_IMPORT_URL,
  DEVICE_RAILWAY_SAMPLE_URL,
  DEVICE_ALERT_CONTACTS_LIST_URL,
  DEVICE_ALERT_CONTACTS_IMPORT_URL,
  DEVICE_ALERT_CONTACTS_SAMPLE_URL,
  deviceAlertContactsUrl,
  DEVICE_DETAILS_URL,
  DEVICE_UPDATE_URL,
  DEVICE_DELETE_URL,
  deviceHistoryUrl,
  deviceActivityUrl,
  deviceLidarTelemetryUrl,
  deviceLidarTelemetryChartUrl,
  deviceSensorTelemetryUrl,
  deviceSensorTelemetryChartUrl,
  deviceUnassignLocationUrl,
  deviceLidarCalUrl,

  // file
  FILE_UPLOAD_URL,

  // DASHBOARD
  DASHBOARD_STATS_URL,
  DASHBOARD_LIVE_URL,
  DASHBOARD_HISTOGRAMS_URL,
  DASHBOARD_HISTOGRAMS_EXPORT_URL,
  DASHBOARD_HISTOGRAMS_EXPORT_DATA_URL,
  PREDICTION_URL,

  // OTA
  OTA_FIRMWARE_UPLOAD_URL,
  OTA_FIRMWARE_LIST_URL,
  OTA_SESSION_LIST_URL,
  OTA_CAMPAIGN_LIST_URL,
  OTA_CAMPAIGN_ACTIVE_URL,
  OTA_DEPLOY_URL,
  otaCampaignRetryUrl,
  otaCampaignLogUrl,
  OTA_EQUIPMENT_TARGETS_URL,
  OTA_TRIGGER_URL,
  OTA_SUBMIT_URL,
  otaClearRetainedUrl,
  otaResetRetryUrl,
};
